import {createFromIconfontCN} from '@ant-design/icons';

export const Icon = createFromIconfontCN({
    scriptUrl: [
        '/iconfont/iconfont_0.0.3.js', // icon-javascript, icon-java, icon-shoppingcart (overrided)
    ],
});

export default Icon;
